/**
 * Predicado del **"audio de palabra"** — el TTS de una palabra suelta que el
 * producto absorbe en vez de cobrárselo al user (decisión del dueño,
 * 2026-09-10; ver `docs/architecture/05-providers-and-billing.md`).
 *
 * Vive acá, compartido cliente ↔ backend, porque los DOS lados lo necesitan y
 * tienen que dar el mismo veredicto:
 *
 *   - El **backend** decide con él si la request es gratis y si el audio va al
 *     catálogo guardado (`lib/word-audio-store.ts`).
 *   - El **cliente** decide con él a qué URL pegarle: una palabra va al `GET`
 *     cacheable por el navegador (`/word-audio/:word`) y una frase al `POST
 *     /speak` de siempre. Si los predicados discreparan, el cliente pediría por
 *     GET algo que el server rechaza con 400.
 *
 * Compartirlo **no** mueve la decisión al cliente: el server lo evalúa sobre el
 * texto que recibe, igual que antes. Un flag del request sí sería "no me
 * cobres" en manos de quien pide el audio; este predicado no es un flag.
 *
 * Una sola excepción, también decidida en el server: el `GET` acepta además
 * las entradas del diccionario activo con espacio (los verbos frasales, `give
 * up`), y la ficha del diccionario las pide por ahí sin pasar por este
 * predicado (misión 66 del catálogo léxico; `routes/english/tts.ts`).
 */

/**
 * Largo máximo de un "audio de palabra". La palabra más larga del inglés de
 * diccionario tiene 45 caracteres; el tope existe para que un texto enorme SIN
 * espacios no entre gratis por la puerta de la política.
 */
export const WORD_AUDIO_MAX_CHARS = 48;

/** ¿Es "audio de palabra"? Una sola palabra, corta. */
export function isWordAudio(text: string): boolean {
  const t = text.trim();
  return t.length > 0 && t.length <= WORD_AUDIO_MAX_CHARS && !/\s/.test(t);
}
